import styled from 'styled-components'
import './style.css'
import { useContext, useRef } from 'react'
import GlobalContext from 'Contexts/GlobalContext'

const Clouds = () => {
  const { colorMode, locale } = useContext(GlobalContext)
  const vizRef = useRef<any>()
  return (
    <PollutionSection>
      <div>
        <Header>
          <h2>
           {locale.clouds.title}
          </h2>
          <p>
           {locale.clouds.lead}
          </p>
        </Header>
      </div>

      <VizContainer ref={vizRef}>
        <LeftLabel>
          <img src={require('./arrow-black.png')} alt='Hinweis auf Abbildung' />
          <div
            style={{
              color: '#000000',
              fontSize: '1.5rem',
              fontWeight: '800',
              backgroundColor: 'var(--yellow-main)',
              padding: '4px 14px',
              borderRadius: 3,
              display: 'inline-block',
              position: 'relative',
              zIndex: 1,
            }}
          >
           { locale.clouds.swissPerson }
          </div>
          <div
            style={{
              color: 'var(--text-color)',
              fontSize: '1.5rem',
              fontWeight: '200',
              marginTop: '10px',
            }}
          >
            <b style={{ fontWeight: 800 }}>Ø 14</b>{' '}
            <small>
              t CO<sub>2</sub>
            </small>
          </div>
        </LeftLabel>
        <figure
          style={{
            width: '15%',
            height: 'auto',
            zIndex: 10,
            animation: 'float-a 6s ease-in-out infinite',
          }}
        >
          <picture>
            <img
              src={require('./round-cloud-stipple' +
                (colorMode === 'dark' ? '-dark' : '') +
                '.png')}
              alt='Co2 Ausstoss von Gigi Oeris Jet'
            />
          </picture>
        </figure>
        <RightLabel>
          <InnerRightLabel>
            <img
              style={{}}
              src={require('./arrow-black.png')}
              alt='Hinweis auf Abbildung'
            />
            <div
              className='pollution-label'
              style={{
                color: '#ffffff',
                fontSize: '1.5rem',
                fontWeight: '800',
                backgroundColor: '#333333',
                padding: '4px 14px',
                borderRadius: 3,
                display: 'inline-block',
                zIndex: 1,
                position: 'relative',
              }}
            >
              { locale.clouds.privateJet }
            </div>
            <div
              className='pollution-value'
              style={{
                color: 'var(--text-color)',
                fontSize: '1.5rem',
                fontWeight: '200',
                marginTop: '10px',
              }}
            >
              <b style={{ color: 'inherit',fontWeight: 800, fontSize: '1.5em' }}>600</b>{' '}
              <small style={{ fontSize: '1.5em' }}>
                t CO<sub>2</sub>
              </small>
            </div>
          </InnerRightLabel>
        </RightLabel>
        <figure
          style={{
            width: '100%%',
            height: 'auto',
            zIndex: 10,
            animation: 'float-a 6s ease-in-out infinite',
          }}
        >
          <picture>
            <img
              src={require('./round-cloud-stipple' +
                (colorMode === 'dark' ? '-dark' : '') +
                '.png')}
              alt='Co2 Ausstoss von Gigi Oeris Jet'
            />
          </picture>
        </figure>
      </VizContainer>

      <Footnote style={{}}>
        <p>
          <b>{locale.clouds.hintTitle}</b> {locale.clouds.hintText}
        </p>
      </Footnote>
    </PollutionSection>
  )
}
const PollutionSection = styled.div`
  background: var(--clouds-background);
  position: relative;
  border-radius: 5px;
  @media (max-width: 768px) {
    margin-left: -1em;
    margin-right: -1em;
    margin-bottom: -3em;
  }
`
const VizContainer = styled.div`
  display: flex;
  position: relative;
  overflow: visible;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 100px;
`

const Header = styled.div`
  padding-top: .5em;
  padding-bottom: 1em;
  text-align: center;
  margin: 1em;

  h2 {
    font-size: 1.5em;
    font-family: var(--font-sans-serif);
    line-height: 1.35;
    color: var(--text-color);
    font-weight: 800;
  }
  p {
    font-size: 0.95em;
    margin-top: 1em;
    font-weight: 200;
  }
`

const LeftLabel = styled.div`
  position: absolute;
  text-align: left;
  left: 50%;
  width: 150px;
  transform: translateX(-100%) translateY(-100%);
  top: 0;
  z-index: 11;
  display: inline-block;
  font-family: var(--font-sans-serif);
  img {
    filter: invert(1);
    width: 100px;
    transform: rotate(70deg);
    position: absolute;
    top: -10px;
    right: 0px;
    z-index: 0;
  }
`

const RightLabel = styled.div`
  text-align: left;
  /* display: inline-block; */
  z-index: 11;
  /* animation: float-b 6s ease-in-out infinite; */
  font-family: var(--font-sans-serif);
  img {
    width: 100px;
    transform: rotate(-90deg) scaleX(-1);
    position: absolute;
    /* top: -70px; */
    left: -50px;
    z-index: 0;
    // invert image
    filter: invert(1);
  }
`
const InnerRightLabel = styled.div`
@media(max-width:450px){
  transform: translateX(70%);
  
}
  transform: translateX(100%);
`

const Footnote = styled.div`
  font-family: var(--font-sans-serif);
  /* padding-bottom: 40; */
  margin: 1em;
  line-height: 1.5;
  padding-bottom: .5em;
  p {
    font-size: 0.805em;
    margin-top: 1em;
    font-weight: 200;
  }
`

export default Clouds
